import { cva } from '@/styled-system/css';

export const upsellHeaderRecipe = cva({
  base: {
    '.c11n_upsell__root:has(.c11n_upsell__close-button) &': {
      paddingInlineEnd: '1000',
    },

    '& > .c11n_heading': {
      color: 'inherit',
      textStyle: 'body-bold',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.neutral',
      },
      soft: {
        color: 'text.neutral',
      },
      hero: {
        color: 'Upsell.Header.hero.text',
      },
      impact: {
        color: 'text.onImpact.neutral',
      },
    },
  },
});
